import { useEffect, useState } from 'react';
import { apiFetch } from '../api/client';

/**
 * Small, non-interactive deploy-verification chip pinned to the bottom-right of the
 * booking form. Shows the frontend BUILD version (`__APP_VERSION__`, baked at vite
 * build) next to the backend version (anonymous `GET /v1/info`); turns amber when
 * they differ so a stale SPA bundle against a freshly deployed API is obvious.
 *
 * `pointer-events-none` ensures it never intercepts taps on the booking controls.
 */
export function VersionBadge() {
  const fe = __APP_VERSION__;
  const [be, setBe] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    apiFetch<{ version: string }>('/v1/info')
      .then((d) => { if (active) setBe(d.version); })
      .catch(() => { /* badge is best-effort; ignore */ });
    return () => { active = false; };
  }, []);

  const mismatch = be !== null && be !== fe;

  return (
    <div
      data-testid="version-badge"
      aria-hidden="true"
      title={
        mismatch
          ? `Frontend build ${fe} differs from backend ${be}`
          : `Frontend build ${fe} · backend ${be ?? 'loading'}`
      }
      className={`pointer-events-none fixed bottom-1 right-1 z-40 select-none rounded px-1.5 py-0.5 font-mono text-[10px] leading-none shadow-sm ${
        mismatch
          ? 'bg-amber-100 text-amber-800 ring-1 ring-amber-300'
          : 'bg-slate-100/80 text-slate-400'
      }`}
    >
      ui {fe}
      {be ? ` · api ${be}` : ''}
    </div>
  );
}
